import React from 'react';

import { getFileType, getIconByFileType, onImageLoadError, openNewWindow } from '@utils/Util';

const FilePreviewer = ({ docUrl, base64Data }) => {
	const renderFilePreview = (docUrl, base64Data) => {
		if (!docUrl && base64Data) return <img src={base64Data} alt={getIconByFileType('FILE')} />;

		const fileType = getFileType(docUrl);
		if (fileType === 'IMAGE' || fileType === 'NO_FILE')
			return (
				<img
					src={docUrl}
					alt="Upload"
					onError={onImageLoadError}
					onClick={() => openNewWindow(docUrl)}
				/>
			);
		else
			return (
				<img
					className="cursor-pointer file-icon"
					src={getIconByFileType(fileType)}
					onClick={() => {
						window.open(docUrl, '_blank').focus();
					}}
				/>
			);
	};

	return <>{renderFilePreview(docUrl, base64Data)}</>;
};

export default FilePreviewer;
